let selectedClubs = [];

function loadData(data) {
    console.log('Loading data:', data);

    const typeSelect = document.getElementById('club-type');
    const brandSelect = document.getElementById('brand');
    const modelSelect = document.getElementById('model');
    const ironSetOptions = document.getElementById('iron-set-options');
    const ironSetInclude = document.getElementById('iron-set-include');
    const form = document.getElementById('trade-in-form');
    const result = document.getElementById('result');

    // Clear existing options
    typeSelect.innerHTML = '<option value="">Select club type</option>';
    brandSelect.innerHTML = '<option value="">Select brand</option>';
    modelSelect.innerHTML = '<option value="">Select model</option>';

    // Load club types
    const types = [...new Set(data.map(item => item.Type))]
        .filter(type => type !== null && type !== '')
        .sort();
    
    types.forEach(type => {
        const option = new Option(type, type);
        typeSelect.appendChild(option);
    });

    // Update brands when type changes
    typeSelect.addEventListener('change', function() {
        result.classList.remove('active');
        resetSteps();
        
        const selectedType = this.value;
        const brands = [...new Set(
            data.filter(item => item.Type === selectedType)
                .map(item => item.Brand)
        )].sort();
        
        brandSelect.innerHTML = '<option value="">Select brand</option>';
        brands.forEach(brand => {
            const option = new Option(brand, brand);
            brandSelect.appendChild(option);
        });
        modelSelect.innerHTML = '<option value="">Select model</option>';

        // Handle iron set options visibility and reset
        const ironSetOptions = document.getElementById('iron-set-options');
        const ironSetInclude = document.getElementById('iron-set-include');
        
        if (selectedType === 'Iron Set') {
            ironSetOptions.style.display = 'block';
            ironSetInclude.setAttribute('required', 'required');
        } else {
            ironSetOptions.style.display = 'none';
            ironSetInclude.removeAttribute('required');
            // Reset iron set selection when switching to non-iron set
            ironSetInclude.value = '';
        }

        // Reset missing clubs checkbox
        document.getElementById('missing-clubs').checked = false;
    });

    // Update models when brand changes
    brandSelect.addEventListener('change', function() {
        result.classList.remove('active');
        resetSteps();
        
        const selectedType = typeSelect.value;
        const selectedBrand = this.value;
        
        const models = [...new Set(
            data.filter(item => 
                item.Type === selectedType && 
                item.Brand === selectedBrand
            ).map(item => item.Model)
        )].sort();
        
        modelSelect.innerHTML = '<option value="">Select model</option>';
        models.forEach(model => {
            const option = new Option(model, model);
            modelSelect.appendChild(option);
        });
    });

    // Handle form submission
    form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const club = data.find(item => 
            item.Type === typeSelect.value &&
            item.Brand === brandSelect.value &&
            item.Model === modelSelect.value
        );

        if (club) {
            const condition = document.querySelector('input[name="condition"]:checked').value;
            let baseValue = club.Price;

            // Apply condition modifiers
            if (condition === 'new') {
                baseValue *= 1.10;
            } else if (condition === 'above-average') {
                baseValue *= 1.0; // No multiplier (1.0)
            } else if (condition === 'average') {
                baseValue *= 0.9;
            } else if (condition === 'poor') {
                baseValue *= 0.8;
            }

            // Apply iron set adjustments if applicable
            if (typeSelect.value === 'Iron Set') {
                const ironSetOption = ironSetInclude.value;
                const missingClubs = document.getElementById('missing-clubs').checked;

                // Apply iron set configuration multipliers based on configuration
                const ironSetMultipliers = {
                    '3-9': 0.875,
                    '3-PW': 1,
                    '3-AW': 1.1,
                    '3-SW': 1.2,
                    '3-LW': 1.2,
                    '4-9': 0.75,
                    '4-PW': 0.875,
                    '4-AW': 1,
                    '4-SW': 1.1,
                    '4-LW': 1.2,
                    '5-9': 0.50,
                    '5-PW': 0.75,
                    '5-AW': 0.875,
                    '5-SW': 1,
                    '5-LW': 1.1,
                    '6-PW': 0.50,
                    '6-AW': 0.75,
                    '6-SW': 0.875,
                    '6-LW': 1
                };

                // Apply multiplier if configuration exists
                if (ironSetMultipliers[ironSetOption]) {
                    baseValue *= ironSetMultipliers[ironSetOption];
                }

                // Apply missing clubs reduction if applicable
                if (missingClubs) {
                    baseValue *= 0.85;
                }
            }

            // Calculate cash value only (no credit option for PGA Pro)
            const cashValue = baseValue;

            updateStepProgress(2);

            result.innerHTML = `
                <div class="result-content animate-fade-in">
                    <div class="club-details">
                        <h3 class="club-name">${club.Brand} ${club.Model}</h3>
                        <p class="club-type">${club.Type}${ironSetInclude.value ? ` (${ironSetInclude.value})` : ''}</p>
                    </div>
                    <div class="cash-value-container">
                        <div class="cash-value-display">
                            <div class="value-amount">$${cashValue.toFixed(2)}</div>
                            <div class="value-label">Cash Value</div>
                        </div>
                    </div>
                    <div class="result-buttons">
                        <button class="add-to-list-button" onclick="addClubToSelection('${club.Brand}', '${club.Model}', '${club.Type}', ${cashValue}, '${ironSetInclude.value}', ${document.getElementById('missing-clubs')?.checked || false})">
                            <span>Add This Club</span>
                            <svg class="button-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                        <button class="trade-another-button" onclick="addClubAndTradeAnother('${club.Brand}', '${club.Model}', '${club.Type}', ${cashValue}, '${ironSetInclude.value}', ${document.getElementById('missing-clubs')?.checked || false})">
                            <span>Add & Trade Another</span>
                            <svg class="button-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                </div>
            `;
            result.classList.add('active');
        }
    });
}

function addClubToSelection(brand, model, type, cashValue, ironSetOption, missingClubs) {
    selectedClubs.push({
        brand,
        model,
        type,
        cashValue,
        ironSetOption,
        missingClubs
    });
    updateSelectedClubsList();
    updateTradeInForm();
    updateStepProgress(3);
}

// New function for "Trade-In Another Item" button
function addClubAndTradeAnother(brand, model, type, cashValue, ironSetOption, missingClubs) {
    // First add the club to selection (same as addClubToSelection)
    selectedClubs.push({
        brand,
        model,
        type,
        cashValue,
        ironSetOption,
        missingClubs
    });
    updateSelectedClubsList();
    updateTradeInForm();
    
    // Reset the form to allow adding another item
    resetFormForNewItem();
    
    // Scroll to top of the page
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

function resetFormForNewItem() {
    // Reset the form
    const form = document.getElementById('trade-in-form');
    form.reset();
    
    // Reset all select dropdowns
    const typeSelect = document.getElementById('club-type');
    const brandSelect = document.getElementById('brand');
    const modelSelect = document.getElementById('model');
    const ironSetInclude = document.getElementById('iron-set-include');
    
    typeSelect.value = '';
    brandSelect.innerHTML = '<option value="">Select brand</option>';
    modelSelect.innerHTML = '<option value="">Select model</option>';
    ironSetInclude.value = '';
    
    // Hide iron set options
    const ironSetOptions = document.getElementById('iron-set-options');
    ironSetOptions.style.display = 'none';
    ironSetInclude.removeAttribute('required');
    
    // Reset missing clubs checkbox
    document.getElementById('missing-clubs').checked = false;
    
    // Reset condition to default (average)
    document.querySelector('input[name="condition"][value="average"]').checked = true;
    
    // Hide result section
    const result = document.getElementById('result');
    result.innerHTML = '';
    result.classList.remove('active');
    
    // Reset steps to step 1
    resetSteps();
    updateStepProgress(1);
}

function removeClubFromSelection(index) {
    selectedClubs.splice(index, 1);
    updateSelectedClubsList();
    updateTradeInForm();
    if (selectedClubs.length === 0) {
        resetSteps();
    }
}

function updateSelectedClubsList() {
    const selectedClubsDiv = document.getElementById('selectedClubs');
    if (selectedClubs.length > 0) {
        let totalValue = 0;
        
        const clubsList = selectedClubs.map((club, index) => {
            const displayValue = club.cashValue;
            totalValue += displayValue;
            
            return `
                <div class="selected-club-item animate-fade-in">
                    <div class="club-info">
                        <span class="club-name">${club.brand} ${club.model} ${club.type} ${club.ironSetOption ? `(${club.ironSetOption})` : ''}</span>
                        <span class="club-value">${displayValue.toFixed(2)} (Cash)</span>
                    </div>
                    <button class="remove-button" onclick="removeClubFromSelection(${index})">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 18L18 6M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>
            `;
        }).join('');

        selectedClubsDiv.innerHTML = `
            <div class="selected-clubs-container animate-fade-in">
                <h3 class="section-title">Selected Clubs</h3>
                <div class="selected-clubs-list">
                    ${clubsList}
                </div>
                <div class="total-value">
                    <span class="total-label">Total Cash Value:</span>
                    <span class="total-amount">${totalValue.toFixed(2)}</span>
                </div>
                <div class="action-buttons">
                    <button class="primary-button" onclick="proceedToTradeInForm()">
                        <span>Continue to Trade-In Form</span>
                        <svg class="button-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                    <button class="secondary-button" onclick="clearSelection()">Start New Quote</button>
                </div>
            </div>
        `;
        selectedClubsDiv.style.display = 'block';
    } else {
        selectedClubsDiv.style.display = 'none';
    }
}

function updateTradeInForm() {
    let clubsList = selectedClubs.map(club => {
        const displayValue = club.cashValue;
        const missingClubsText = club.missingClubs ? " (Incomplete Set)" : "";
        return `${club.brand} ${club.model} ${club.type} ${club.ironSetOption ? `(${club.ironSetOption}${missingClubsText})` : ''} - ${displayValue.toFixed(2)} (Cash)`;
    }).join(', ');

    const clubsListTextarea = document.querySelector('textarea[data-type="textarea"]');
    if (clubsListTextarea) {
        clubsListTextarea.value = clubsList;
    }
}

function clearSelection() {
    selectedClubs = [];
    updateSelectedClubsList();
    updateTradeInForm();
    resetSteps();
    document.getElementById('trade-in-form').reset();
    document.getElementById('result').innerHTML = '';
    document.getElementById('result').classList.remove('active');
}

function proceedToTradeInForm() {
    const formSection = document.getElementById('tradeInFormSection');
    formSection.style.display = 'block';
    formSection.scrollIntoView({ behavior: 'smooth' });
    updateTradeInForm();
}

function updateStepProgress(stepNumber) {
    const steps = document.querySelectorAll('.step');
    steps.forEach((step, index) => {
        if (index < stepNumber) {
            step.classList.add('active');
        }
    });
}

function resetSteps() {
    const steps = document.querySelectorAll('.step');
    steps.forEach((step, index) => {
        if (index > 0) {
            step.classList.remove('active');
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    console.log('Document ready');
    const dataUrl = window.GOLF_CLUBS_URL;
    console.log('Attempting to fetch from:', dataUrl);

    if (!dataUrl) {
        console.error('Golf clubs data URL not found');
        showError('Configuration error - please contact support');
        return;
    }

    fetch(dataUrl)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
        })
        .then(text => {
            console.log('Raw response first 100 chars:', text.substring(0, 100));
            try {
                const data = JSON.parse(text);
                if (Array.isArray(data)) {
                    console.log(`Successfully loaded ${data.length} clubs`);
                    loadData(data);
                } else {
                    throw new Error('Data is not an array');
                }
            } catch (e) {
                console.error('JSON parsing error:', e);
                throw e;
            }
        })
        .catch(error => {
            console.error('Error loading golf clubs data:', error);
            showError('Unable to load club data. Please refresh the page or try again later.');
        });
});

function showError(message) {
    const result = document.getElementById('result');
    if (result) {
        result.innerHTML = `
            <div class="error-message">
                ${message}
            </div>
        `;
    }
}